// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__39vLj","label":"CategoryService_label__3GAYl","location":"CategoryService_location__24veF"};